import { useCallback, useEffect, useState } from 'react';

/**
 * Custom hook for scroll to top functionality with visibility control
 * Simple implementation focusing on window scroll
 */
export const useScrollToTop = (threshold = 200) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollTop =
            window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
          const shouldShow = scrollTop > threshold;
          setIsVisible(shouldShow);
          ticking = false;
        });
        ticking = true;
      }
    };

    // Use window scroll event for best compatibility
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Initial check
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [threshold]);

  const scrollToTop = useCallback(() => {
    // Use smooth scrolling if supported
    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    } catch (error) {
      // Fallback for older browsers
      window.scrollTo(0, 0);
    }
  }, []);

  return { scrollToTop, isVisible };
};
